// Module
var code = "<div class=\"widget-content\"> <wt-loading-panel is-loading=\"vm.isLoading\"></wt-loading-panel> <p style=\"margin-bottom:10px;height:100%\">{{vm.stacktrace(vm.selectedLog)}}</p> </div>";
// Exports
module.exports = code;